export default {
	getById(id, cb, ecb, config) {
		this.http
			.get(`/task/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/task/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByCode(code, cb, ecb) {
		this.http
			.get(`/task/getByCode/${code}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/task/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/task/search/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb, config) {
		this.http
			.get(`/task/status/${id}/${to}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
